import React from 'react';
import { PawPrint } from 'lucide-react';
import { siteConfig } from '../data/siteConfig';
export function SiteFooter() {
  return <footer className="bg-forest-dark px-5 pb-[110px] pt-[34px] text-center text-[13.5px] text-[#9FC0AE] md:pb-10" data-id="element-281" data-mp="3r8rjcwvgwm1j">
      <div className="mb-3 flex items-center justify-center gap-2.5 font-display text-[15px] font-extrabold tracking-[0.16em] text-tangerine-light" data-id="element-282" data-mp="3mfpxu60r9o8z">
        <PawPrint className="h-[18px] w-[18px]" fill="currentColor" aria-hidden="true" data-id="element-283" data-mp="3dh4lwtpsh7h6" />
        PASEO PRO
      </div>
      <p className="mx-auto my-1.5 max-w-[720px]" data-id="element-284" data-mp="38gqffg3u65l9">
        Kit de negocio para paseadores y cuidadores de mascotas · Producto 100% digital.
      </p>
      <p className="mx-auto my-1.5 max-w-[720px]" data-id="element-285" data-mp="2yjln0yjeddw0">
        Soporte:{' '}
        <a href={`mailto:${siteConfig.supportEmail}`} className="break-all text-tangerine-light underline-offset-2 hover:underline" data-id="element-286" data-mp="2yletodu0fy40">
          {siteConfig.supportEmail}
        </a>
      </p>
      <p className="mx-auto mt-3.5 max-w-[720px] text-xs opacity-80" data-id="element-287" data-mp="wsqo3xtw8yl2">
        Los documentos incluidos son modelos orientativos y no constituyen asesoramiento legal. Te
        recomendamos adaptarlos a la normativa de tu país. Los resultados dependen del uso que hagas
        del material.
      </p>
      <p className="mx-auto my-1.5 max-w-[720px] text-xs opacity-80" data-id="element-288" data-mp="vu8sepjuyik1">
        © {new Date().getFullYear()} PASEO PRO. Todos los derechos reservados.
      </p>
    </footer>;
}